// $(document).ready(function(){
//     function handleMenuHoverAndClick(sectionId) {
//         var $section = $(sectionId);
//         $section.find('.mob-childlink-title').on('mouseenter click', function() {
//             var target = $(this).data('target');
//             $section.find('.mob-childlink-title').removeClass('activeHover');
//             $(this).addClass('activeHover');
//             $section.find('.main-megamenu-item-inner').removeClass('activeItem');
//             $(target).addClass('activeItem');
//         });
//     }
//     for (var i = 1; i <= 5; i++) {
//         var sectionId = '#Details-menu-drawer-menu-item-' + i;
//         handleMenuHoverAndClick(sectionId);
//     }
//     $('.menu-drawer__menu li details summary').click(function() {
//         var details = $(this).parent('details');
//         $('.menu-drawer__menu li details').not(details).removeAttr('open');
//     });
// });
const childlinkTitles = document.querySelectorAll('.mob-childlink-title');
  const megamenuInnerProducts = document.querySelectorAll('.main-megamenu-item-inner');
  childlinkTitles.forEach((title, index) => {
    title.addEventListener('click', () => {
      megamenuInnerProducts.forEach(product => {
        product.classList.remove('activeItem');
      });
      megamenuInnerProducts[index].classList.add('activeItem');
    });
  });
$(document).ready(function() {
$(".mob-childlink-title").click(function () {
    $(".mob-childlink-title").removeClass("activeHover");
    $(this).addClass("activeHover");   
});
});
